export { RangeSelectMap as default, RangeSelectMap } from "./RangeSelectMap";
